import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { refreshUserProfile } = useAuth();

  useEffect(() => {
    const processPayment = async () => {
      console.log('Processing payment... refreshing user profile.');
      await refreshUserProfile();
      console.log('Profile refreshed. Redirecting...');
      const returnTo = sessionStorage.getItem('returnTo') || '/';
      sessionStorage.removeItem('returnTo');
      navigate(returnTo, { replace: true });
    };

    processPayment();
  }, [navigate, refreshUserProfile]);

  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <p className="text-lg font-semibold">Processing your payment...</p>
        <p>Please wait, you will be redirected shortly.</p>
      </div>
    </div>
  );
};

export default PaymentSuccess;
